import { FormProvider, useForm } from 'react-hook-form';

import { SetupStepForm } from './SetupStepForm';
import { SubmitSuccessHandlerFn } from './types';

type SetupStepProps = {
  onClose: () => void;
  onSubmit: SubmitSuccessHandlerFn;
};

export const SetupStep = ({ onClose, onSubmit }: SetupStepProps) => {
  const form = useForm();
  return (
    <FormProvider {...form}>
      <SetupStepForm onClose={onClose} onSubmit={onSubmit} />
    </FormProvider>
  );
};
